import { createPrefetchableAsyncDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getRootPageData } from './api/getRootPageData';
import type { StarterDashboardPageDataLoadError } from './types';

export const {
	Context: StarterDashboardPageDataContext,
	Provider: StarterDashboardPageDataContextProvider,
	useContext: useStarterDashboardPageData,
	useAsyncData: useStarterDashboardPageDataFromApi,
	prefetchAsyncData: prefetchStarterDashboardPageDataFromApi,
} = createPrefetchableAsyncDataContext({
	name: 'StarterDashboardPageDataContext',
	dataProperty: 'pageData',
	getData: getRootPageData,
	hookDeps: ({ slug, countryCode, locale }) => [slug, countryCode, locale],
	getUniqueId: ({ slug }) => slug,
	errorHandler: pageDataErrorHandler<StarterDashboardPageDataLoadError>(),
});
